import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare `/dev-resources/transitions` has no pane of its own — land on the stacked member.
export const Route = createFileRoute('/_app/dev-resources/transitions/')({
  beforeLoad: () => {
    throw redirect({ to: '/dev-resources/transitions/one' })
  },
})
